(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-gate"]) return;
  try {
    
  const KLAVIYO_REVISION = '2026-07-15';

  const initializePasswordGate = (gate) => {
    if (gate.dataset.passwordGateInitialized === 'true') return;
    gate.dataset.passwordGateInitialized = 'true';
    const accessDialog = gate.querySelector('[data-access-dialog]');
    const accessMessage = gate.querySelector('[data-access-message]');
    const closeAccessButton = gate.querySelector('[data-close-access]');
    const emailInput = gate.querySelector('[data-notify-email]');
    const honeypot = gate.querySelector('[data-notify-honeypot]');
    const notifyForm = gate.querySelector('[data-notify-form]');
    const notifyMessage = gate.querySelector('[data-notify-message]');
    const notifySubmit = gate.querySelector('[data-notify-submit]');
    const openAccessButton = gate.querySelector('[data-open-access]');
    const passwordInput = gate.querySelector('input[name="password"]');

    const openAccessDialog = () => {
      if (!accessDialog.open) accessDialog.showModal();
      passwordInput.focus();
    };

    openAccessButton.addEventListener('click', openAccessDialog);
    closeAccessButton.addEventListener('click', () => accessDialog.close());

    accessDialog.addEventListener('click', (event) => {
      if (event.target === accessDialog) accessDialog.close();
    });

    if (accessMessage.dataset.hasErrors === 'true') openAccessDialog();

    emailInput.addEventListener('input', () => {
      emailInput.removeAttribute('aria-invalid');
      notifyMessage.textContent = '';
      notifyMessage.removeAttribute('data-state');
    });

    notifyForm.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (!emailInput.checkValidity()) {
        notifyMessage.textContent = gate.dataset.invalidEmail;
        notifyMessage.dataset.state = 'error';
        emailInput.setAttribute('aria-invalid', 'true');
        emailInput.focus();
        return;
      }

      if (honeypot.value) {
        notifyMessage.textContent = gate.dataset.signupSuccess;
        notifyMessage.dataset.state = 'success';
        return;
      }

      const publicApiKey = gate.dataset.klaviyoPublicApiKey;
      const listId = gate.dataset.klaviyoListId;

      if (!publicApiKey || !listId) {
        notifyMessage.textContent = gate.dataset.signupError;
        notifyMessage.dataset.state = 'error';
        return;
      }

      const originalLabel = notifySubmit.textContent;
      notifySubmit.textContent = gate.dataset.submittingLabel;
      notifySubmit.disabled = true;

      try {
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(publicApiKey)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            revision: KLAVIYO_REVISION,
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: gate.dataset.klaviyoSource,
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: emailInput.value.trim().toLowerCase(),
                      subscriptions: {
                        email: {
                          marketing: {
                            consent: 'SUBSCRIBED',
                          },
                        },
                      },
                    },
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: listId,
                  },
                },
              },
            },
          }),
        });

        if (!response.ok) throw new Error('Subscription request failed');

        notifyMessage.textContent = gate.dataset.signupSuccess;
        notifyMessage.dataset.state = 'success';
        notifySubmit.textContent = gate.dataset.successLabel;
        emailInput.disabled = true;
      } catch {
        notifyMessage.textContent = gate.dataset.signupError;
        notifyMessage.dataset.state = 'error';
        notifySubmit.textContent = originalLabel;
        notifySubmit.disabled = false;
      }
    });
  };

  document.querySelectorAll('[data-password-gate]').forEach(initializePasswordGate);

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches?.('[data-password-gate]')) initializePasswordGate(event.target);
    event.target.querySelectorAll?.('[data-password-gate]').forEach(initializePasswordGate);
  });

  } catch(e) { console.error(e); }
})();
})();
